import React from 'react';
import _ from 'lodash';
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
} from 'react-admin';
import { isRequired } from '../../validators';
import { offeringCategory } from '../../helpers/mappings';

export default props => (
  <Create
    {...props}
    title="Create Offer Campaign"
  >
    <SimpleForm redirect="edit">
      <ReferenceInput
        label="Offer"
        source="offerId"
        reference="offerings"
        validate={isRequired}
        perPage={100}
      >
        <SelectInput
          optionText={choice => `${choice.name} (${_.values(offeringCategory).find(item => item.value === choice.category).label})`}
        />
      </ReferenceInput>
      <TextInput label="Campaign Name" source="title" validate={isRequired} />
      <TextInput label="Campaign Subject" source="subjectLine" validate={isRequired} />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/OfferCampaign/Create.js